import { IObservable, Subject } from '~/rage/utils';
import { Apps } from '~/shared';
import { RpcService } from '../RpcService';
import { ITabletService } from './tabletServiceTypes';

export class TabletService implements ITabletService {
	private activeApp = new Subject<Apps | null>(null);

	constructor(private readonly rpc: RpcService) {
		this.rpc.register('tablet:setActiveApp', (app: Apps | null) => {
			this.activeApp.next(app);
		});
	}

	public getActiveApp(): IObservable<Apps | null> {
		return this.activeApp;
	}
}
